import Model from './Model';

export default class EmployeeLogin extends Model {
    resource() {
        return 'employees/login';
    }
}
